<template>
  <header class="header flex items-center bg-white border-solid border-b border-0 border-soft">
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>
  .header {
    height: 100px;
    min-height: 100px;
  }
</style>
